import React from 'react';

const PayPerVideoPricing = () => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-5 lg:p-6">
      {/* Header */}
      <div className="flex items-start justify-between gap-3 mb-4 sm:mb-5">
        <div className="flex items-center gap-2 min-w-0">
          <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-brand-red flex items-center justify-center shrink-0">
            <span className="text-white text-[10px] sm:text-xs leading-none">►</span>
          </div>

          <div className="min-w-0">
            <h2 className="text-sm sm:text-base lg:text-lg font-bold text-gray-900 truncate">
              Pay-Per-Video
            </h2>
            <p className="text-[11px] sm:text-xs lg:text-sm text-gray-500">
              No subscription needed
            </p>
          </div>
        </div>

        <span className="shrink-0 px-2 sm:px-2.5 py-0.5 sm:py-1 rounded-full text-[10px] sm:text-xs font-medium bg-gray-100 text-gray-700">
          Flexible
        </span>
      </div>

      {/* Price tiers */}
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 xl:grid-cols-3 gap-2.5 sm:gap-3 lg:gap-2.5 xl:gap-3 text-center mb-4 sm:mb-5">
        <div className="rounded-xl bg-gray-50 p-3 sm:p-3.5 lg:p-3 xl:p-3.5">
          <div className="text-[10px] sm:text-xs font-semibold text-gray-500 uppercase mb-1">≤30 min</div>
          <div className="text-xl sm:text-2xl lg:text-xl xl:text-2xl font-extrabold text-gray-900">$3.99</div>
        </div>

        <div className="rounded-xl bg-gray-50 p-3 sm:p-3.5 lg:p-3 xl:p-3.5">
          <div className="text-[10px] sm:text-xs font-semibold text-gray-500 uppercase mb-1">30–60 min</div>
          <div className="text-xl sm:text-2xl lg:text-xl xl:text-2xl font-extrabold text-gray-900">$5.99</div>
        </div>

        <div className="rounded-xl bg-gray-50 p-3 sm:p-3.5 lg:p-3 xl:p-3.5">
          <div className="text-[10px] sm:text-xs font-semibold text-gray-500 uppercase mb-1">60–120 min</div>
          <div className="text-xl sm:text-2xl lg:text-xl xl:text-2xl font-extrabold text-gray-900">$9.99</div>
        </div>
      </div>

      <hr className="border-gray-200 mb-3 sm:mb-4" />

      {/* Bullets */}
      <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm lg:text-xs xl:text-sm text-gray-700">
        <li className="flex items-start gap-2 sm:gap-2.5">
          <span className="w-4 h-4 sm:w-5 sm:h-5 mt-0.5 bg-green-100 text-green-600 text-[9px] sm:text-[10px] rounded-full flex items-center justify-center shrink-0">
            ✔
          </span>
          <span>Pay only when needed</span>
        </li>
        <li className="flex items-start gap-2 sm:gap-2.5">
          <span className="w-4 h-4 sm:w-5 sm:h-5 mt-0.5 bg-green-100 text-green-600 text-[9px] sm:text-[10px] rounded-full flex items-center justify-center shrink-0">
            ✔
          </span>
          <span>Works even on free plan</span>
        </li>
        <li className="flex items-start gap-2 sm:gap-2.5">
          <span className="w-4 h-4 sm:w-5 sm:h-5 mt-0.5 bg-green-100 text-green-600 text-[9px] sm:text-[10px] rounded-full flex items-center justify-center shrink-0">
            ✔
          </span>
          <span>Videos saved to storage</span>
        </li>
      </ul>
    </div>
  );
};

export default PayPerVideoPricing;
